export const DOMAIN = 'assessmentsReporting';
